import React, { useContext, useState, useEffect } from 'react';
import { Box, Button, Card, CircularProgress, Typography } from '@material-ui/core';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';
import { RootStoreContext } from '../../global/storeContext';
import { paths } from '../../routes';

export const IdentityVerificationGate: React.FC<{ children: React.ReactNode }> = observer(
  ({ children }) => {
    const { userStore } = useContext(RootStoreContext);
    const navigate = useNavigate();
    const [status, setStatus] = useState<'loading' | 'verified' | 'unverified'>('loading');

    useEffect(() => {
      userStore.getAccountSetupSteps().then((steps) => {
        setStatus(
          steps?.IDENTITY_VERIFIED && steps.USER_PROFILE_COMPLETE ? 'verified' : 'unverified',
        );
      });
    }, [userStore]);

    if (status === 'loading') {
      return (
        <Box display='flex' justifyContent='center' alignItems='center' minHeight='40vh'>
          <CircularProgress />
        </Box>
      );
    }

    if (status === 'unverified') {
      return (
        <Box display='flex' justifyContent='center' alignItems='center' minHeight='100%' flexGrow={1}>
          <Card style={{ maxWidth: 480, padding: '2rem', textAlign: 'center' }}>
            <LockOutlinedIcon style={{ fontSize: 48, color: '#999' }} />
            <Typography variant='h6' gutterBottom style={{ marginTop: '1rem' }}>
              Complete Profile &amp; ID Verification
            </Typography>
            <Typography variant='body1' gutterBottom style={{ marginTop: '0.5rem' }}>
              You need to complete your profile and verify your identity to access this feature.
            </Typography>
            <Button
              variant='contained'
              color='primary'
              onClick={() => navigate(paths.account.personalInfo)}
              style={{ marginTop: '1.5rem' }}
            >
              Complete Setup
            </Button>
          </Card>
        </Box>
      );
    }

    return <>{children}</>;
  },
);
